import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '../../redux/slices/appSlice';
import './LibraryTab.scss';

// Mobile web-only hub for "your stuff" — Likes, Favourite Artists,
// Playlists — plus Crate Digger which feeds off that same library
// signal. Spotify/SoundCloud both group these under a single Library
// tab on mobile; we do the same.
const LibraryTab = () => {
    const dispatch = useDispatch();
    const likesCount = useSelector((s) => s.likes?.likedTracks?.length || s.likes?.total || 0);
    const favsCount = useSelector((s) => s.followedArtists?.artists?.length || s.followedArtists?.total || 0);
    const playlistsCount = useSelector((s) => s.playlist?.playlists?.length || 0);

    const items = [
        {
            key: 'likes',
            label: 'Liked Tracks',
            desc: likesCount ? `${likesCount} track${likesCount === 1 ? '' : 's'}` : 'Tracks you like show up here',
            Icon: () => (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
            ),
        },
        {
            key: 'followed-artists',
            label: 'Favourite Artists',
            desc: favsCount ? `${favsCount} artist${favsCount === 1 ? '' : 's'}` : 'Follow DJs to track their mixes',
            Icon: () => (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <polygon points="18 12 19.8 15.5 23.5 16 21 18.5 21.5 22 18 20 14.5 22 15 18.5 12.5 16 16.2 15.5" />
                </svg>
            ),
        },
        {
            key: 'playlists',
            label: 'Playlists',
            desc: playlistsCount ? `${playlistsCount} playlist${playlistsCount === 1 ? '' : 's'}` : 'Your saved playlists',
            Icon: () => (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M15 6H3" /><path d="M15 12H3" /><path d="M15 18H3" />
                    <circle cx="19" cy="18" r="2" /><path d="M21 6V16" />
                </svg>
            ),
        },
        // Crate Digger lives in the bottom nav ("Digger") on mobile, so it's
        // intentionally not duplicated here in the Library hub.
    ];

    return (
        <div className="tab-container library-tab">
            <div className="lower-part">
                <h3 className="library-title">Library</h3>
                <ul className="library-list">
                    {items.map(({ key, label, desc, Icon }) => (
                        <li key={key}>
                            <button className="library-item" onClick={() => dispatch(setActiveTab(key))}>
                                <span className="library-item-icon"><Icon /></span>
                                <span className="library-item-text">
                                    <span className="library-item-label">{label}</span>
                                    <span className="library-item-desc">{desc}</span>
                                </span>
                                <svg className="library-item-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default LibraryTab;
